import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AlertService } from '@app/@core/services/alert.service';
import { MenuItem } from 'primeng/api';
import { DataSourceService } from './@core/data-source.service';


@Component({
  standalone: false,
  selector: 'app-data-source',
  templateUrl: './data-source.component.html',
  styleUrls: ['./data-source.component.scss']
})
export class DataSourceComponent implements OnInit {

  items: MenuItem[] = [];
  activeItem!: MenuItem;
  isEdit: boolean
  schema: any[] = [];
  value!: string;
  userid: any;
  dbaliasname: any;
  organizationid: any;
  settingForm!: UntypedFormGroup;
  checkedSchema: any;
  selectSchema: any[];
  listSchema: any[] = [];
  auditEnabledList= [{
    key: 'Yes',
    value: true,
  }, {
      key : 'No',
      value: false
    }];
  auditEnabled: any;

  constructor(
    private alertService: AlertService,
    private formBuilder: UntypedFormBuilder,
    private settingService: DataSourceService) {
    // This is intentional
  }

  ngOnInit(): void {
    this.getOrganizationDbs();
    this.initializeForm();
    this.isEdit = false;
    this.settingForm.disable();

  }
  initializeForm() {
    this.settingForm = this.formBuilder.group({
      id: ['', Validators.required],
      organizationid: ['', Validators.required],
      databasetype: ['', Validators.required],
      host: [''],
      port: ['', Validators.required],
      password: ['', Validators.required],
      username: ['', [Validators.required, Validators.pattern(AppConstants.regexEmail)]],
      database_name: ['', Validators.required],
      dbaliasname: ['', Validators.required],
      selectedschemas: ['', Validators.required],
      created_by: ['', Validators.required],
      created_at: ['', Validators.required],
      updated_by: ['', Validators.required],
      updated_at: ['', Validators.required],
      soft_delete: ['', Validators.required],
      audit_enabled: [false, Validators.required],
    });
  }
  getOrganizationDbs() {
    this.settingService.getOrganizationDbs().subscribe((res: any) => {
      this.userid = res.data.id;
      this.organizationid = res.data.organizationid;
      this.dbaliasname = res.data.dbaliasname

      const additionalInfo = res.data.additionalinfo
      const reservedFields = additionalInfo?.reserved_fields ? additionalInfo.reserved_fields : {};
      this.settingForm.patchValue({
        id: res.data.id,
        organizationid: res.data.organizationid,
        databasetype: res.data.databasetype,
        host: res.data.host,
        port: res.data.port,
        password: res.data.password,
        username: res.data.username,
        database_name: res.data.database_name,
        dbaliasname: res.data.dbaliasname,
        created_by : reservedFields.created_by ? reservedFields.created_by : '',
        created_at : reservedFields.created_at ? reservedFields.created_at : '',
        updated_by : reservedFields.updated_by ? reservedFields.updated_by : '',
        updated_at : reservedFields.updated_at ? reservedFields.updated_at : '',
        soft_delete : reservedFields.soft_delete ? reservedFields.soft_delete : '',
        audit_enabled : reservedFields.audit_enabled ? reservedFields.audit_enabled : false
      })
      this.schemaSelect();
      this.schemaCheckData();
    })
  }
  addUser() {
    this.isEdit = true;
    const userData = this.settingForm.getRawValue();
    if (this.settingForm.valid) {
      userData.id = this.userid;
      userData.organizationid = userData.organizationid || [];
      userData.databasetype = userData.databasetype || [];
      userData.host = userData.host || [];
      userData.port = userData.port || [];
      userData.password = userData.password || [];
      userData.username = userData.username || [];
      userData.database_name = userData.database_name || [];
      userData.dbaliasname = userData.dbaliasname || [];
    }
    if (!this.userid) {
      this.userWithOutId(userData);
    } else {
      this.userWithID(userData);
    }
  }

  userWithOutId(_userData: any) {
    console.log()
  }

  userWithID(data) {
    data?.selectedschemas.length && data.selectedschemas.forEach(element => {
      this.listSchema.push({
        'organizationid': this.organizationid,
        'db_id': this.userid,
        'schema': element
      })
    });
    const {created_by, created_at , updated_at, updated_by, soft_delete, audit_enabled, ...dbConfig } = data;
    const newConfig = {
      ...dbConfig,
      additionalinfo : {
        reserved_fields: {
          created_by,
          created_at,
          updated_by,
          updated_at,
          soft_delete,
          audit_enabled
        }
      }
    }
    this.settingService.updateData(newConfig).subscribe(
      () => {
        this.schemaUpdate(this.listSchema);
        this.getOrganizationDbs();
        this.isEdit = false;
        this.alertService.success(' Updated successfully');

        this.settingForm.disable();
      },
      (err: any) => {
        if (err.error.message) {
          this.alertService.error(err.error.message);
        } else {
          this.alertService.error('Failed to update');
        }
      }
    );
  }
  schemaUpdate(data) {
    this.settingService.updateSchemaList(data).subscribe(
      () => {
        this.schemaCheckData();
        this.listSchema = [];
      },
      (err: any) => {
        if (err.error.message) {
          this.alertService.error(err.error.message);
        } else {
          this.alertService.error('Failed to update');
        }
      }
    )
  }
  cancel() {
    this.getOrganizationDbs();
    this.isEdit = false;
    this.settingForm.disable();
  }
  editStatus() {
    this.isEdit = true;
    this.settingForm.enable();
  }
  schemaSelect() {
    this.settingService.getSchema(this.dbaliasname).subscribe((res: any) => {
      console.log(res)
      res.data.forEach(element => {
        this.schema.push(element.name)
      });
      console.log(this.schema);
    })
  }

  schemaCheckData() {
    this.settingService.SchemaCheck(this.organizationid, this.dbaliasname).subscribe((res: any) => {
      console.log(res);
      this.checkedSchema = res.data;
      this.selectSchema = this.schema
        .filter(a => this.checkedSchema.some(b => b.name === a))
        .map(a => a);
    })
  }


}
